import styled from "styled-components";

export const FiltersCont = styled.div(
  (props) => `
    border-radius: 1.2rem;
    background-color: #fff;
    overflow: hidden;

    .filtersHeading {
        font-size: 1.8rem;
        padding: 2rem 1.5rem;
        color: #141823;
        border-bottom: solid 0.1rem #e1e7ee;

        .filtersText {
            font-weight: 600;
            font-family: 'Rubik';
        }

        .clearText {
            float: right;
            font-size: 1.2rem;
            text-transform: uppercase;
            color: ${props.theme.colors.grey.grey50};
            cursor: pointer;
        }

        .filtersSubHeading {
            font-size: 1.2rem;
            line-height: 1.33;
            margin-top: 0.6rem;
            color: ${props.theme.colors.grey.grey75}
        }
    }

    ul.segmentWrap {
        padding: 2rem 1.5rem;
        border-bottom: solid 0.1rem #e1e7ee;

        li {
            padding: 0.8rem;
            display: flex;
            flex-direction: column;
            border-radius: 0.8rem;
            border: solid 0.1rem #e9f6ea;
            margin-bottom: 1.2rem;

            &:last-child {
                margin-bottom: 0;
            }


            .segmentInfo {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                margin-top: 0.5rem;

                >p {
                    max-width: 185px;
                    font-size: 1.2rem;
                    color: #4f525a;
                    display: flex;
                    justify-content: space-between;
                }
            }
        }

    }
`
);

export const FilterRows = styled.div`
  flex-shrink: 0;
  position: sticky;
  top: 10rem;

  h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 2rem;
    line-height: 2rem;
    margin-bottom: 1rem;
    color: #000000;

    a {
      font-size: 1.4rem;
    }
  }
`;

export const FilterRow = styled.li`
  width: 100%;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  border-bottom: solid 0.1rem #e1e7ee;

  h4 {
    font-weight: 600;
    font-size: 1.6rem;
    color: #000;
    line-height: 1.33;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ul li {
    margin-bottom: 1.4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .resetText {
    font-size: 1.2rem;
    font-weight: normal;
    color: #898b91;
    cursor: pointer;
  }

  .ratingLabel {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.3rem;
    height: 1.9rem;
    border-radius: 0.2rem;
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    &.plus4 {
      background-color: #18a160;
    }
    &.plus35 {
      background-color: #79d148;
    }
    &.plus3 {
      background-color: #bfed01;
    }
    &.plus1 {
      background-color: #ff713e;
    }
  }

  .input-range {
    padding: 2rem 0;
  }

  .input-range > .input-range__label--min,
  .input-range > .input-range__label--max {
    display: none;
  }

  .input-range .input-range__label--value {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5.9rem;
    height: 2.2rem;
    background-color: #2276e3;
    font-weight: 600;
    line-height: 1.29rem;
    color: #ffffff;
    border-radius: 0.3rem;
  }

  .input-range .input-range__label-container {
    position: static;
    font-weight: 600;
    font-size: 13px;
  }

  .input-range .input-range__track--active {
    background-color: #2276e3;
  }

  .input-range .input-range__track {
    height: 0.9rem;
    border-radius: 0.5rem;
  }

  .input-range .input-range__slider {
    width: 1.8rem;
    height: 1.8rem;
    object-fit: contain;
    border: solid 0.2rem #2276e3;
    background: #ffffff;
    margin-top: -1.5rem;
  }

  .input-range .input-range__label--value {
    display:none;
    top: -3.2rem;
  }

  .input-range
    .input-range__track
    .input-range__slider-container:last-child
    .input-range__label {
    top: 0.9rem;
  }
`;

export const FilterRowLI = styled.li`
  margin-bottom: 1.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const BackToTopBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.6rem;
  border-radius: 1.2rem;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
  font-family: 'Rubik';
  font-size: 1.6rem;
  font-weight: 600;
  overflow: hidden;
  border: #fff;
`;

export const Shape = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  margin: 0.3rem 0 0.3rem 0.8rem;
  padding: 0.3rem 0 0 0;
  background-color: #2276e3;
`;
